import PurchaseOrders from "../../../laboratory/purchaseOrders";

// approved purchase orders of the branch, received here when the delivery arrives
export default function PurchaseProcess() {
  return <PurchaseOrders approver initialTab="approved" />;
}
